module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_facebook-da2e01a5cd2919317a8078eb1709dd1d.svg";